import React from 'react';

export default class Section extends React.Component {
    /**
     * @method render
     * @returns {JSX.Element}
     */
    render () {
        const {children, title} = this.props;

        return (
            <div className="max-w-5xl mx-auto px-12 sm:px-4 lg:px-24 py-12 text-center space-y-6 my-auto">
                {children}
            </div>
        )
    };
}
